
import { ApiService } from "../../config/apiServices";
import { ADMIN_CREATE_CATEGORY_URL, ADMIN_GET_CATEGORY_BY_ID_URL, ADMIN_GET_CATEGORY_LIST_URL, ADMIN_UPDATE_CATEGORY_URL, ADMIN_USER_LEVEL_LIST_URL, CREATE_CATEGORY_TYPE_URL, GET_CATEGORY_TYPE_BY_ID_URL, GET_CATEGORY_TYPE_URL, GET_CATEGORY_URL, UPDATE_CATEGORY_TYPE_URL } from "../../config/superadmin/superadminUrlConfig";



export const getAllUserCategory = () => {
  return ApiService.get(GET_CATEGORY_URL);
}

export const getAllCategoryType = (perPage,currentPage) => {
    return ApiService.get(`${GET_CATEGORY_TYPE_URL}?number=${perPage}&page=${currentPage}`);
  };

  export const createCategoryType = (data) => {
    return ApiService.post(CREATE_CATEGORY_TYPE_URL,data);
  }

  export const getCategoryTypeById = (categoryId) => {
    return ApiService.get(`${GET_CATEGORY_TYPE_BY_ID_URL}${categoryId}`);
   
  }
  
  export const updateCategoryType = (editData,id) => {
    return ApiService.post(`${UPDATE_CATEGORY_TYPE_URL}${id}`, editData);
    
  }


  // AdminCategory
  export const getAllAdminCategory = (perPage,currentPage) => {
    return ApiService.get(`${ADMIN_GET_CATEGORY_LIST_URL}?number=${perPage}&page=${currentPage}`);
  
  }

export const getAllAdminLevel = () => {
    return ApiService.get(ADMIN_USER_LEVEL_LIST_URL);
  };

  export const createCategoryAdmin = (data) => {
    return ApiService.post(ADMIN_CREATE_CATEGORY_URL,data);
  }

  export const getCategoryAdminById = (categoryId) => {
    return ApiService.get(`${ADMIN_GET_CATEGORY_BY_ID_URL}${categoryId}`);
   
  }
  
  export const updateAdminCategoryType = (editData,id) => {
    return ApiService.post(`${ADMIN_UPDATE_CATEGORY_URL}${id}`, editData);
    
  }